import { useState } from 'react';
import Drawer from 'react-modern-drawer';
import 'react-modern-drawer/dist/index.css';
import SideDrawer from './Sidedrawer';
import postagerLogo from '../../../assets/logo.png';
import nike from '../../../assets/logos/nike.png';

const TopBar = ({ menu, selectedPage, setSelectedPage }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };

  return (
    <div>
      <div className="px-5 py-2 flex items-center justify-between">
        <button className="space-y-2" onClick={toggleDrawer}>
          <div className="w-7 h-0.5 bg-gray-600"></div>
          <div className="w-7 h-0.5 bg-gray-600"></div>
          <div className="w-7 h-0.5 bg-gray-600"></div>
        </button>
        <img
          className="w-[60%] object-contain pt-2"
          src={postagerLogo}
          alt="Postager Logo"
        />
        <img className="w-8" src={nike} alt="Nike" />
      </div>
      <Drawer
        open={isOpen}
        onClose={toggleDrawer}
        direction="left"
        className="bla bla bla"
      >
        <SideDrawer
          menu={menu}
          selectedPage={selectedPage}
          setSelectedPage={setSelectedPage}
        />
      </Drawer>
    </div>
  );
};

export default TopBar;
